import type { FC } from "react";

import classNames from "classnames";

import styles from "./FlavourRating.module.scss";

export type FlavourProperties = {
  label: string;
  rating: 0 | 0.5 | 1 | 1.5 | 2 | 2.5 | 3 | 3.5 | 4 | 4.5 | 5;
};

export const FlavourRating: FC<FlavourProperties> = ({ rating, label }) => {
  return (
    <div className={styles.ratingRow}>
      <div className={styles.label}>{label}</div>
      <div className={styles.flavourRating}>
        {Array.from({ length: 5 }).map((_, index) => {
          const ratingDotValue = index + 1;

          return (
            <span
              key={index}
              className={classNames(styles.ratingDot, {
                [styles.ratingDotActive]: ratingDotValue <= rating,
                [styles.ratingDotHalf]: ratingDotValue - 0.5 === rating,
              })}
            />
          );
        })}
      </div>
    </div>
  );
};
